export const userRegistrationPreCheck = {
    title: 'IBA User Registration',
    selectPlaceholder: 'Please select',
    purposeOfUse: 'Purpose of Use',
    purposeOfUseOptions: {
        proposal: 'For proposal activities',
        consulting: 'For consulting delivery',
        marketing: 'For marketing activities',
        selfImprovement: 'For self-improvement',
        training: 'For training',
        development: 'For development and test',
        others: 'Others'
    },
    applicationStatus: 'IBA Application Status',
    applicationStatusOptions: {
        applied: 'Applied',
        notApplied: 'Not applied'
    },
    assuranceBusiness: 'Assurance Business',
    assuranceBusinessDescription: 'Will IBA be used for assurance business?',
    assuranceBusinessOptions: {
        yes: 'Yes',
        no: 'No'
    },
    isqm1: 'Will you use it for ISQM1-related work?',
    isqm1Description:
        'IBA cannot be used for work related to ISQM1 in cases where Cons uses IBA under Assurance. If you use IBA for Assurance work, will you use it for work related to ISQM1?',
    isqm1Options: {
        yes: 'Yes',
        no: 'No'
    },
    submit: 'Next',
    errorRequired: 'This field is required',
    errorNotApplied: 'IBA application is required. Please register again after applying.',
    errorIsqm1: 'IBA cannot be used for work related to ISQM1.',
    applicationFormLink: 'Open application form'
}
